import * as React from 'react';

import { TooltipModel } from '@notino/react-styleguide';

import { PortalTooltip } from '@components/PortalTooltip';
import { ICharacteristic } from '@containers/ProductListing/model';

import { useNewPdDesignEnabled } from '../../hooks/useNewPdDesignEnabled';

import {
  CharacteristicName,
  CharacteristicRow,
  CharacteristicValue,
  TooltipContentWrapper,
} from './styled';

interface IProps {
  item: ICharacteristic;
  fullWidth: boolean;
}

export const Characteristic = ({
  item: { name, help, values },
  fullWidth,
}: IProps) => {
  const newPdDesignEnabled = useNewPdDesignEnabled();

  return (
    <CharacteristicRow
      newPdDesignEnabled={newPdDesignEnabled}
      fullWidth={fullWidth}
    >
      <CharacteristicName
        isTooltip={!!help}
        newPdDesignEnabled={newPdDesignEnabled}
      >
        {help ? (
          <PortalTooltip
            position={TooltipModel.Position.topRight}
            content={
              <PortalTooltip.Content>
                <TooltipContentWrapper>{help}</TooltipContentWrapper>
              </PortalTooltip.Content>
            }
          >
            {name}
          </PortalTooltip>
        ) : (
          name
        )}
      </CharacteristicName>

      <CharacteristicValue newDesign={newPdDesignEnabled}>
        {values.join(', ')}
      </CharacteristicValue>
    </CharacteristicRow>
  );
};
